var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector9(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 141,
    viewBox: "0 0 135 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5292 104.665V67.7717C38.5292 63.471 40.881 56.5677 52.0961 48.1156C56.9521 44.5134 62.1368 41.3798 67.581 38.7567C73.0262 41.3795 78.2118 44.5131 83.0685 48.1156C94.281 56.573 96.6354 63.4762 96.6354 67.7717V104.665H38.5292ZM101.287 14.957C84.7382 4.52091 67.9573 0.117937 67.7927 0.0760037L67.4974 0L67.2047 0.0760037C67.0375 0.117937 50.4107 4.53139 33.9381 14.957C18.631 24.6514 0.318791 41.671 0 67.7193V141H135V67.7193C135 41.6762 116.667 24.6514 101.292 14.957",
    fill: "#F4DB49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector9);
export default __webpack_public_path__ + "static/media/Vector-9.35f35bb1c94259d302b3ad2c63796561.svg";
export { ForwardRef as ReactComponent };